class CalorstatWebservice {
    /*
     * FR SEARCH
     */
    static getManufacturers(params = {}) {
        const url = `${cal.api_url}/api/Product/GetManufacturers`;

        CalorstatWebservice._getData(url, params);
    }

    static getModelsByManufacturer(params = {}) {
        const url = `${cal.api_url}/api/Product/GetModelsByManufacturer?manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}`;

        CalorstatWebservice._getData(url, params);
    }

    static getEnginesByManufacturerAndModel(params = {}) {
        const url = `${cal.api_url}/api/Product/GetEnginesByManufacturerAndModel?manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}&model=${CalorstatWebservice._encodeData(params.data.model)}`;

        CalorstatWebservice._getData(url, params);
    }

    // static getPeriodsByManufacturerAndModelAndEngine(params = {}) {
    //     const url = `${cal.api_url}/api/Product/GetPeriodsByManufacturerAndModelAndEngine?manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}&model=${CalorstatWebservice._encodeData(params.data.model)}&engine=${CalorstatWebservice._encodeData(params.data.engine)}`;

    //     CalorstatWebservice._getData(url, params);
    // }

    static getYearsByManufacturerAndModelAndEngine(params = {}) {
        const url = `${cal.api_url}/api/Product/GetYearsByManufacturerAndModelAndEngine?manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}&model=${CalorstatWebservice._encodeData(params.data.model)}&engine=${CalorstatWebservice._encodeData(params.data.engine)}`;

        CalorstatWebservice._getData(url, params);
    }

    static getProductsByManufacturerAndModelAndEngineAndPeriod(params = {}) {
        const url = `${cal.api_url}/api/Product/GetProductsByManufacturerAndModelAndEngineAndPeriod?manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}&model=${CalorstatWebservice._encodeData(params.data.model)}&engine=${CalorstatWebservice._encodeData(params.data.engine)}&year=${CalorstatWebservice._encodeData(params.data.first_registration_year)}`;

        CalorstatWebservice._getData(url, params);
    }

    // static getFamiliesByManufacturerAndModelAndEngineAndPeriod(params = {}) {
    //     const url = `${cal.api_url}/api/Product/GetFamiliesByManufacturerAndModelAndEngineAndPeriod?manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}&model=${CalorstatWebservice._encodeData(params.data.model)}&engine=${CalorstatWebservice._encodeData(params.data.engine)}&period=${CalorstatWebservice._encodeData(params.data.period)}`;

    //     CalorstatWebservice._getData(url, params);
    // }

    static getFamiliesByManufacturerAndModelAndEngineAndYear(params = {}) {
        let url = `${cal.api_url}/api/Product/GetFamiliesByManufacturerAndModelAndEngineAndYear?manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}&model=${CalorstatWebservice._encodeData(params.data.model)}&engine=${CalorstatWebservice._encodeData(params.data.engine)}&year=${CalorstatWebservice._encodeData(params.data.first_registration_year)}&market=${CalorstatWebservice._encodeData(params.data.market)}`;

        CalorstatWebservice._getData(url, params);
    }

    /*
     * USA SEARCH
     */
    static getYears(params = {}) {
        const url = `${cal.api_url}/api/Product/GetYears`;

        CalorstatWebservice._getData(url, params);
    }

    static getManufacturersByYear(params = {}) {
        const url = `${cal.api_url}/api/Product/GetManufacturersByYear?year=${CalorstatWebservice._encodeData(params.data.years)}`;

        CalorstatWebservice._getData(url, params);
    }

    static getModelsByYearAndManufacturer(params = {}) {
        const url = `${cal.api_url}/api/Product/GetModelsByYearAndManufacturer?year=${CalorstatWebservice._encodeData(params.data.years)}&manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}`;

        CalorstatWebservice._getData(url, params);
    }

    static getFamiliesByYearAndManufacturerAndModel(params = {}) {
        const url = `${cal.api_url}/api/Product/GetFamiliesByYearAndManufacturerAndModel?year=${CalorstatWebservice._encodeData(params.data.years)}&manufacturer=${CalorstatWebservice._encodeData(params.data.manufacturer)}&model=${CalorstatWebservice._encodeData(params.data.model)}&market=${CalorstatWebservice._encodeData(params.data.market)}`;

        CalorstatWebservice._getData(url, params);
    }

    /*
     * PRODUCT DETAILS
     */
    static getApplications(params = {}) {
        const url = `${cal.api_url}/api/Product/GetApplications?id=${CalorstatWebservice._encodeData(params.id)}`;

        CalorstatWebservice._getData(url, params);
    }

    static getLogistics(params = {}) {
        const url = `${cal.api_url}/api/Product/GetLogistics?id=${CalorstatWebservice._encodeData(params.id)}`;

        CalorstatWebservice._getData(url, params);
    }

    static getDocuments(params = {}) {
        const url = `${cal.api_url}/api/Product/GetDocuments?id=${CalorstatWebservice._encodeData(params.id)}`;

        CalorstatWebservice._getData(url, params);
    }

    static _encodeData(data) {
        return encodeURIComponent(data);
    }

    static _getData(url, params) {
        const request = $.getJSON(url);

        if(params.onSuccess) {
            request.done(params.onSuccess);
        }
        if(params.onError) {
            request.fail(params.onError);
        }
        if(params.onComplete) {
            request.always(params.onComplete);
        }
    }
}

export default CalorstatWebservice;
